import { render, staticRenderFns } from "./dCheckbox.vue?vue&type=template&id=0fa6fde6&"
import script from "./dCheckbox.vue?vue&type=script&lang=js&"
export * from "./dCheckbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports